import type { AgencyData } from '@/gql/reviews'
import { ReviewsAgencyRouteTabs, ReviewsRouteName } from '@/router/types'

import { hasItems, hasText, hasTranslationValue, type SectionConfig } from './completionTypes'

export const agencyCompletionSections: SectionConfig<AgencyData>[] = [
  {
    id: ReviewsAgencyRouteTabs.Details,
    labelKey: 'Reviews.profileCompletion.section.details',
    editRouteName: ReviewsRouteName.ReviewsAgencyEditDetails,
    fields: [
      { key: 'logo', isComplete: (a) => !!a.logo },
      { key: 'shortDescription', isComplete: (a, l) => hasTranslationValue(a.shortDescriptionTranslations, l) },
      {
        key: 'description',
        isComplete: (a, l) => a.configFlags.descriptionLongEditable && hasTranslationValue(a.descriptionTranslations, l),
      },
      { key: 'url', isComplete: (a, l) => hasTranslationValue(a.urlTranslations, l) },
      { key: 'hero', isComplete: (a) => !!a.hero },
      { key: 'categories', isComplete: (a) => hasItems(a.categories) },
      { key: 'linkedin', isComplete: (a) => a.configFlags.socialLinksAllowed && hasText(a.linkedin) },
      { key: 'twitter', isComplete: (a) => a.configFlags.socialLinksAllowed && hasText(a.twitter) },
      {
        key: 'secondaryCta',
        isComplete: (a, l) =>
          a.configFlags.ctaSecondaryEditable && (hasTranslationValue(a.ctaSecondaryUrlTranslations, l) || hasText(a.ctaSecondary?.url)),
      },
      { key: 'locations', isComplete: (a) => hasItems(a.locations) },
    ],
  },
  {
    id: ReviewsAgencyRouteTabs.IndustriesAndServices,
    labelKey: 'Reviews.profileCompletion.section.industriesAndServices',
    editRouteName: ReviewsRouteName.ReviewsAgencyEditIndustriesAndServices,
    fields: [
      { key: 'industries', isComplete: (a) => hasItems(a.assignedIndustries) },
      { key: 'services', isComplete: (a) => hasItems(a.assignedFeatures) },
    ],
  },
  {
    id: ReviewsAgencyRouteTabs.Traits,
    labelKey: 'Reviews.profileCompletion.section.traits',
    editRouteName: ReviewsRouteName.ReviewsAgencyEditTraits,
    fields: [{ key: 'traits', isComplete: (a) => hasItems(a.traits) }],
  },
  {
    id: ReviewsAgencyRouteTabs.Partners,
    labelKey: 'Reviews.profileCompletion.section.partners',
    editRouteName: ReviewsRouteName.ReviewsAgencyEditPartners,
    fields: [{ key: 'partners', isComplete: (a) => hasItems(a.toolPartners) }],
  },
  {
    id: ReviewsAgencyRouteTabs.Assets,
    labelKey: 'Reviews.profileCompletion.section.assets',
    editRouteName: ReviewsRouteName.ReviewsAgencyEditAssets,
    fields: [
      { key: 'screenshots', isComplete: (a) => hasItems(a.screenshots) },
      { key: 'documents', isComplete: (a) => hasItems(a.documents) },
    ],
  },
]
